import { EventHandler } from "./event-handler.model";

export class EventTypeSubscriptionMasterData {
  eventHandler: Array<EventHandler>;
}
